import i18n from "i18next";
import Modal from "@/Components/Modals/Modal";
import {loadPayments} from '@ministrybrands/payments-js/pure';
import {Inertia} from "@inertiajs/inertia";
import React, {useEffect, useState, useRef} from "react";
import AmplifySpinner from "@/Components/AmplifySpinner";
import {ButtonDangerOutline} from "@/Components/Buttons/ButtonDangerOutline";
import {ButtonPrimary} from "@/Components/Buttons/ButtonPrimary";

export default function EditPaymentDetailsModal({state, dispatch, apiKey}) {
    const [isLoading, setIsLoading] = useState(true);
    const [shouldDisableSubmit, setShouldDisableSubmit] = useState(false);
    let paymentDetails = useRef(null);
    const paymentsEnv = () => {
        let lowerCasedEnv = state.pbEnv.toLowerCase();
        console.log('env', lowerCasedEnv);
        if (lowerCasedEnv === 'dev1') {
            return 'dev';
        } else if (lowerCasedEnv === 'production') {
            return 'prd';
        } else if (lowerCasedEnv === 'test1') {
            return 'dev';
        } else if (lowerCasedEnv === 'stg') {
            return 'stg';
        } else if (lowerCasedEnv === 'beta') {
            return 'beta';
        } else if (lowerCasedEnv === 'int') {
            return 'int';
        } else {
            console.log('ENVIRONMENT VARIABLE DID NOT MATCH A VALUE; SHOWING AS: ', state.env);
            return 'dev';
        }
    };

    useEffect(()=> {
        const getPayments = async() => {
            const instance = await loadPayments(paymentsEnv(), apiKey);
            return instance;
        };

        getPayments().then((payments) => {
            axios.get(route('manage.billing.tokenizeAccess')).then(res => {
                const {clientSecret} = res.data;
                const components = payments.components({"clientSecret": clientSecret});
                paymentDetails.current = components.create("paymentDetails");
                paymentDetails.current.mount("payment-container");
            }).then(() => setIsLoading(false)
            ).catch(error => {
                Inertia.post(
                    route('manage.billing.failure'),
                    {success: false, message: JSON.stringify(error.response.data.message)}
                );
            });
        });

        const destroyPayments = () => {
            let node = document.getElementById("payment-container");
            if (node)
                node.replaceChildren();
            paymentDetails.current = null;
        }

        return () => destroyPayments();
        }, []);

    const handleSubmit = () => {
        setShouldDisableSubmit(true);
        // @TODO: Passes TokenID back to server for processing, could use Flashes for success / fail messages?
        paymentDetails.current.submit()
            .then((value) => {
                dispatch({ type: "editPaymentDetailsModal", payload: { editPaymentDetailsModal: false }});

                axios.post(route('manage.billing.success'), value)
                    .then(() => {
                        dispatch({ type: "editPaymentDetailsModal", payload: { editPaymentDetailsModal: false }});
                        Inertia.reload();
                    })
                    .catch(() => setShouldDisableSubmit(false));
                }
            )
            .catch(() => setShouldDisableSubmit(false));
    }

    return (
        <Modal isOpen={state.editPaymentDetailsModal}
               title={i18n.t("billing.edit-payment-details")}
               dialogClassName="edit-dialog"
               modalClassName="edit-modal manage-subscriptions-modal"
               disableClickAway={true}
               setIsOpen={() => dispatch({ type: "editPaymentDetailsModal", payload: { editPaymentDetailsModal: false}})}>
            <div id="payment-container" className="cc-modal">
            { isLoading && <AmplifySpinner /> }
            </div>
            { !isLoading &&
            <div className="modal-actions">
                <ButtonDangerOutline
                    disabled={shouldDisableSubmit}
                    className="modal-cancel"
                    onClick={() => dispatch({ type: "editPaymentDetailsModal", payload: { editPaymentDetailsModal: false }}) }
                >{i18n.t("billing.cancel")}</ButtonDangerOutline>
                <ButtonPrimary
                    disabled={shouldDisableSubmit}
                    onClick={handleSubmit}
                >{i18n.t("billing.save")}</ButtonPrimary>
            </div>
            }


        </Modal>
    )
}
